import { useState, useEffect } from 'react';

const ServicesAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth < 1024);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const services = [
    {
      id: 1,
      title: "Social Media Marketing",
      subtitle: "Strategische Präsenz & Engagement",
      description: "Wir entwickeln massgeschneiderte Social Media Strategien, die Ihre Marke zum Leben erwecken. Von Content Creation über Community Management bis hin zu bezahlten Kampagnen - wir sorgen für nachhaltiges Wachstum und echte Verbindungen mit Ihrer Zielgruppe.",
      icon: "📱",
      features: [
        "Content Strategy & Planning",
        "Community Management",
        "Paid Social Advertising",
        "Analytics & Reporting"
      ],
      color: "#1B857F"
    },
    {
      id: 2,
      title: "Video Production",
      subtitle: "Visuelle Geschichten, die begeistern",
      description: "Von Konzept bis Post-Production erstellen wir hochwertige Videoinhalte, die Ihre Botschaft kraftvoll vermitteln. Ob Werbespots, Imagefilme oder Social Media Content - wir bringen Ihre Vision zum Leben.",
      icon: "🎬",
      features: [
        "Konzept & Storyboarding",
        "Professionelle Aufnahmen",
        "Motion Graphics & Animation",
        "Post-Production & Editing",
        "Multi-Platform Distribution"
      ],
      color: "#2C3E50"
    },
    {
      id: 3,
      title: "Web Design & Development",
      subtitle: "Moderne, responsive Websites",
      description: "Wir entwickeln benutzerfreundliche, performante Websites, die Ihre Marke optimal präsentieren. Von elegantem Design bis zu komplexen Funktionen - wir schaffen digitale Erlebnisse, die überzeugen.",
      icon: "💻",
      features: [
        "Responsive Web Design",
        "E-Commerce Lösungen",
        "CMS Integration",
        "SEO Optimierung",
        "Performance Monitoring"
      ],
      color: "#34495E"
    },
    {
      id: 4,
      title: "Performance Marketing",
      subtitle: "Data-driven Growth",
      description: "Mit datengetriebenen Ansätzen optimieren wir Ihre Marketing-Kampagnen für maximale ROI. Von Google Ads über Facebook Ads bis hin zu Conversion-Optimierung - wir sorgen für messbare Ergebnisse.",
      icon: "📈",
      features: [
        "Google Ads Management",
        "Facebook & Instagram Ads",
        "Conversion Rate Optimization",
        "A/B Testing",
        "ROI Tracking & Analytics"
      ],
      color: "#27AE60"
    },
    {
      id: 5,
      title: "Content Creation",
      subtitle: "Engaging Content, der begeistert",
      description: "Wir erstellen fesselnde Inhalte, die Ihre Zielgruppe ansprechen und zum Handeln motivieren. Von Blog-Artikeln über Social Media Posts bis hin zu E-Mail Marketing - wir sorgen für konsistente, wertvolle Inhalte.",
      icon: "✍️",
      features: [
        "Content Strategy",
        "Blog & Artikel Writing",
        "Social Media Content",
        "E-Mail Marketing",
        "Copywriting"
      ],
      color: "#E67E22"
    }
  ];

  const containerStyle = {
    backgroundColor: '#000000',
    padding: isMobile ? '80px 24px' : '120px 80px',
    fontFamily: 'PPNeueMontreal, sans-serif',
  };

  const contentStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
  };

  const titleStyle = {
    fontSize: isMobile ? '28px' : isTablet ? '52px' : '64px',
    fontWeight: '500',
    color: '#FFFFFF',
    marginBottom: isMobile ? '16px' : '24px',
    textAlign: 'center',
  };

  const subtitleStyle = {
    fontSize: isMobile ? '16px' : isTablet ? '22px' : '26px',
    color: '#9CA3AF',
    marginBottom: isMobile ? '60px' : '80px',
    textAlign: 'center',
    lineHeight: 1.6,
  };

  const accordionStyle = {
    display: 'grid',
    gap: isMobile ? '16px' : '24px',
  };

  const getServiceStyle = (index) => {
    const isActive = index === activeIndex;
    
    return {
      backgroundColor: '#000000',
      borderRadius: '16px',
      border: `1px solid ${isActive ? '#FFFFFF' : '#1F2937'}`,
      overflow: 'hidden',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      cursor: 'pointer',
      boxShadow: 'none',
      transform: isActive ? 'scale(1)' : 'scale(1)',
    };
  };

  const headerStyle = {
    padding: isMobile ? '24px' : isTablet ? '40px' : '48px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    transition: 'all 0.3s ease',
  };

  const headerContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: isMobile ? '8px' : '12px',
    flex: 1,
  };

  const numberStyle = {
    fontSize: isMobile ? '12px' : isTablet ? '18px' : '22px',
    color: '#6B7280',
    fontWeight: '300',
    marginBottom: '4px',
  };

  const titleContentStyle = {
    flex: 1,
  };

  const serviceTitleStyle = {
    fontSize: isMobile ? '20px' : isTablet ? '30px' : '36px',
    fontWeight: '600',
    color: '#FFFFFF',
    marginBottom: '0px',
    transition: 'color 0.3s ease',
  };

  const serviceSubtitleStyle = {
    fontSize: isMobile ? '12px' : isTablet ? '17px' : '20px',
    color: '#9CA3AF',
    fontWeight: '400',
    letterSpacing: '0.025em',
  };

  const arrowButtonStyle = {
    width: isMobile ? '40px' : isTablet ? '56px' : '64px',
    height: isMobile ? '40px' : isTablet ? '56px' : '64px',
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  };

  const arrowStyle = {
    fontSize: isMobile ? '14px' : isTablet ? '20px' : '24px',
    color: '#000000',
    transition: 'all 0.3s ease',
    transform: 'rotate(0deg)',
    fontWeight: '600',
  };

  const accordionContentStyle = {
    maxHeight: '0px',
    overflow: 'hidden',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  };

  const activeContentStyle = {
    maxHeight: '500px',
    padding: isMobile ? '0 24px 24px' : isTablet ? '0 40px 40px' : '0 48px 48px',
  };

  const descriptionStyle = {
    fontSize: isMobile ? '14px' : isTablet ? '19px' : '22px',
    color: '#D1D5DB',
    lineHeight: 1.7,
    marginBottom: isMobile ? '24px' : '28px',
  };

  const featuresGridStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
    gap: isMobile ? '12px' : '16px',
  };

  const featureStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: isMobile ? '13px' : isTablet ? '16px' : '18px',
    color: '#ffffff',
    padding: isMobile ? '10px 0px' : isTablet ? '16px 0px' : '18px 0px',
    borderRadius: '8px',
    fontWeight: '400',
  };

  const bulletStyle = {
    fontSize: isMobile ? '10px' : isTablet ? '12px' : '14px',
    color: 'rgba(255, 255, 255, 0.7)',
    marginRight: '8px',
  };

  return (
    <section style={containerStyle}>
      <div style={contentStyle}>
        <h2 style={titleStyle}>Unsere Services</h2>
        <p style={subtitleStyle}>
          Entdecken Sie unser umfassendes Portfolio an digitalen Lösungen
        </p>

        <div style={accordionStyle}>
          {services.map((service, index) => {
            const isActive = index === activeIndex;
            
            return (
              <div
                key={service.id}
                style={getServiceStyle(index)}
                onClick={() => setActiveIndex(index)}
              >
                                <div style={headerStyle}>
                  <div style={headerContentStyle}>
                    <div style={numberStyle}>
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    <div style={titleContentStyle}>
                      <h3 style={serviceTitleStyle}>
                        {service.title}
                      </h3>
                      <p style={serviceSubtitleStyle}>{service.subtitle}</p>
                    </div>
                  </div>
                  <button
                    style={arrowButtonStyle}
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveIndex(index);
                    }}
                  >
                    <div style={{
                      ...arrowStyle,
                      transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}>
                      ↓
                    </div>
                  </button>
                </div>
                
                <div style={{
                  ...accordionContentStyle,
                  ...(isActive ? activeContentStyle : {}),
                }}>
                  <p style={descriptionStyle}>{service.description}</p>
                  <div style={featuresGridStyle}>
                    {service.features.map((feature, featureIndex) => (
                      <div key={featureIndex} style={featureStyle}>
                        <span style={bulletStyle}>•</span>
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesAccordion; 